import type { MartinLabActionKey, MartinLabEventActionKey } from "../../src/contracts/product-lab";

export const martinLabActionLabels: Readonly<Record<MartinLabActionKey, string>> = {
  "solicitation.release": "Release solicitation",
  "supplier.rfq.release": "Release supplier RFQ",
  "supplier.response.record": "Record supplier response",
  "award.confirm": "Confirm award package",
  "supplier.po.release": "Release supplier PO",
  "field.report.submit": "Submit Field Service Report",
  "portal.share.grant": "Share supplier portal workspace",
  "billing.issue": "Issue billing batch"
};

/** Historical audit rows remain legible without making retired actions executable. */
export const martinLabEventLabel = (actionKey: MartinLabEventActionKey): string =>
  actionKey === "quickbooks.simulate"
    ? "Legacy QuickBooks simulation (retired)"
    : martinLabActionLabels[actionKey];
